import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";
import { CgSpinner } from "react-icons/cg";
export default function AtmPayRollPopUp({
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
  list,
  token,
}) {
  console.log("List to be printed in the console", list);
  const dispatch = useDispatch();
  const { NoDataFound, currentList, PaginationIndex } = useSearchPagination(
    list ? list : []
  );
  const [selectedCategory, setSelectedCategory] = useState("PAYROLL");
  const [downloadLoading, setDownloading] = React.useState(false);
  var titles = [
    "S.NO.",
    "EMPLOYEE ID",
    "CLIENT",
    "VISA PROVIDER",
    "IQAMA NUMBER",
  ];

  const update = async (type) => {
    setDownloading(true);
    console.log("clicked log to be printed in the console", type);
    try {
      console.log(type);
      const res = await nodeinstance.post("/atm-payroll/updateCategory", type, {
        headers: { Authorization: `Bearer ${token}` },
        body: type,
      });
      console.log(res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setDownloading(false);
        setPopUp(false);
        callBack();
      }
    } catch (error) {
      setDownloading(false);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div
          className="max-w-3xl w-full  rounded-md bg-white/95 flex  flex-col p-5 relative"
          style={{ height: "500px" }}
        >
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>

          <div className="flex flex-row gap-2 align-baseline justify-center items-center">
            <h2 className="text-xl">{title}</h2>
          </div>
          <div className="flex flex-row">
            <h2 className="label place-items-center">TOTAL SELECTED</h2>
            <h2 className="label place-items-center font-bold">
              {list.length}
            </h2>
          </div>

          <div className="flex flex-row gap-[4rem] align-baseline items-center">
            <h2 className="label place-items-center">PAYROLL</h2>
            <div className="text-sm flex flex-col gap-y-1">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="category"
                  value="PAYROLL"
                  checked={selectedCategory === "PAYROLL"}
                  onChange={handleCategoryChange}
                />
                <p>PAYROLL</p>
              </label>
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="category"
                  value="PERSONAL"
                  checked={selectedCategory === "PERSONAL"}
                  onChange={handleCategoryChange}
                />
                <p>PERSONAL</p>
              </label>
            </div>
            <button
              className="p-2 px-4 h-10 rounded-md bg-red disabled:bg-gray text-white min-w-fit text-sm flex items-center "
              onClick={() =>
                update({
                  employee_id: list.map((emp) => emp.employee_id),
                  PayrollCategory: selectedCategory,
                })
              }
              // disabled={downloadLoading || list?.isLoading}
            >
              Update
              {downloadLoading && <CgSpinner className="animate-spin" />}
            </button>
            {/* <div className="border-[3px] p-1 border-[#F5D50A]">

              <button className="bg-red text-white font-semibold px-2 py-1  rounded-sm text-sm" onClick={() => >UPDATE</button>
            </div> */}
          </div>

          <div
            className={`grid grid-cols-table-atm-pop-update auto-cols-min gap-5 p-6  w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
          >
            {titles.map((t, index) => (
              <p key={index} className="font-semibold uppercase">
                {t}
              </p>
            ))}
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading
              ? currentList?.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>{list.employee_id}</p>
                    <p>{list.client}</p>
                    <p>{list.visa_provider}</p>
                    <p>{list.iqama_number}</p>
                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))
              : ""}
          </div>
        </div>
      </div>
    </>
  );
}
